import { render, staticRenderFns } from "./46addDelModel.vue?vue&type=template&id=fb49a1a8&scoped=true&"
import script from "./46addDelModel.vue?vue&type=script&lang=js&"
export * from "./46addDelModel.vue?vue&type=script&lang=js&"
import style0 from "./46addDelModel.vue?vue&type=style&index=0&id=fb49a1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb49a1a8",
  null
  
)

export default component.exports